import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { FormField } from "@babackapp/ui/components/form";
import FormInputContainer from "@babackapp/react-hook-forms-components/form-input-container";
import FormMultiOptionsSelector from "@babackapp/react-hook-forms-components/form-multi-options-selector";
import FormSimpleCron from "@babackapp/react-hook-forms-components/form-simple-cron";
import { useFormContext } from "react-hook-form";
// import FormSimpleCron from "@babackapp/react-hook-forms-components/form-simple-cron";
import useTranslation from "@babackapp/translations/use-translation";
import { ExportSettingsFormValues } from "./export-settings-form";
import ModelSelector from "./model-selector";

/**
 * TODO: Create Model
 */
export default function ExportOptionsForm() {
  const { control } = useFormContext<ExportSettingsFormValues>();
  const t = useTranslation();
  const resolutionOptions = useResolutionOptions();
  const statusesOptions = useStatusesOptions();

  return (
    <div className="flex flex-col gap-8">
      <FormField
        control={control}
        name="options.cron"
        render={({ field }) => (
          <FormSimpleCron
            label={t("settings.integrations.exports.addExport.time.title")}
            description={t(
              "settings.integrations.exports.addExport.time.description",
            )}
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />

      <FormField
        control={control}
        name="options.modelId"
        render={({ field }) => (
          <FormInputContainer
            label={t("settings.integrations.exports.addExport.model.title")}
            description={t(
              "settings.integrations.exports.addExport.model.description",
            )}
          >
            <ModelSelector value={field.value} onChange={field.onChange} />
          </FormInputContainer>
        )}
      />

      <FormField
        control={control}
        name="options.resolutions"
        render={({ field }) => (
          <FormMultiOptionsSelector
            label={t(
              "settings.integrations.exports.addExport.resolutions.title",
            )}
            description={t(
              "settings.integrations.exports.addExport.resolutions.description",
            )}
            options={resolutionOptions}
            values={field.value}
            onChange={field.onChange}
          />
        )}
      />

      <FormField
        control={control}
        name="options.statuses"
        render={({ field }) => (
          <FormMultiOptionsSelector
            label={t("settings.integrations.exports.addExport.statuses.title")}
            description={t(
              "settings.integrations.exports.addExport.statuses.description",
            )}
            options={statusesOptions}
            values={field.value}
            onChange={field.onChange}
          />
        )}
      />
    </div>
  );
}

function useResolutionOptions() {
  const t = useTranslation();
  return [
    {
      label: t("misc.refund"),
      key: "refund",
    },
    {
      label: t("misc.exchange"),
      key: "exchange",
    },
    {
      label: t("misc.discount"),
      key: "discount",
    },
  ];
}

function useStatusesOptions() {
  const { data: shop } = useCurrentShopSuspense();
  const t = useTranslation();

  const logisticianStatuses = shop?.workflowLogistician.activated
    ? [
        {
          label: t("returnDetail.status.partiallyTreatedLogistician"),
          key: "partiallyTreatedLogistician",
        },
        {
          label: t("returnDetail.status.treatedLogistician"),
          key: "treatedLogistician",
        },
      ]
    : [];

  return [
    {
      label: t("returnDetail.status.created"),
      key: "created",
    },
    {
      label: t("returnDetail.status.approved"),
      key: "approved",
    },
    {
      label: t("returnDetail.status.waiting"),
      key: "waiting",
    },
    {
      label: t("returnDetail.status.shipping"),
      key: "shipping",
    },
    {
      label: t("returnDetail.status.shipped"),
      key: "shipped",
    },

    {
      label: t("returnDetail.status.partiallyTreatedMerchant"),
      key: "partiallyTreatedMerchant",
    },
    {
      label: t("returnDetail.status.treatedMerchant"),
      key: "treatedMerchant",
    },
    {
      label: t("returnDetail.status.error"),
      key: "error",
    },
    ...logisticianStatuses,
  ];
}
